import { normalize } from "normalizr";
import endpoints from "api/endpoints";
import Immutable from "immutable";
import { cryptocurrency } from "schemas";

export default (
  {
    resultKey = "cryptocurrency",
    cryptoId,
    alias,
    shortName,
    fullName,
    ticker,
    colorBg,
    color,
    limits,
    step,
    digits,
    icon,
    priority,
    minWithdrawalAmount,
    maxWithdrawalAmount,
    minInputAmount,
    inputCommission,
    withdrawalCommission,
    alwaysQuote,
  } = { resultKey: "cryptocurrency" }
) => ({
  url: endpoints.getActionCryptoUrl(cryptoId),
  transform: (response) =>
    normalize(response.data, cryptocurrency.cryptocurrencySchema).entities,
  transformResult: (response) => ({
    [resultKey]: normalize(response.data, cryptocurrency.cryptocurrencySchema)
      .result,
  }),
  queryKey: endpoints.getActionCryptoUrl(cryptoId),
  meta: {
    authToken: true,
  },
  body: {
    alias,
    shortName,
    fullName,
    ticker,
    colorBg,
    color,
    limits,
    step,
    digits,
    icon,
    priority,
    minWithdrawalAmount,
    maxWithdrawalAmount,
    minInputAmount,
    inputCommission,
    withdrawalCommission,
    alwaysQuote,
  },
  force: true,
  options: {
    headers: {
      Accept: "application/json",
    },
    method: "PUT",
  },
  update: {
    cryptocurrency: (prevCryptocurrency = Immutable.Map(), crypto) =>
      prevCryptocurrency.mergeDeep(crypto),
  },
});
